import { useLanguage } from "@/hooks/useLanguage";
import { getSlogan, isSloganEnabled, type SloganSection } from "@/lib/branding/slogan";

interface BrandSloganProps {
  section: SloganSection;
  className?: string;
  size?: "xs" | "sm" | "md" | "lg";
  withProduct?: boolean;
  align?: "left" | "center";
}

const SIZE_MAP: Record<NonNullable<BrandSloganProps["size"]>, string> = {
  xs: "text-[10px]",
  sm: "text-xs",
  md: "text-sm",
  lg: "text-base",
};

/**
 * PR-35 — Reusable, elegant slogan badge.
 * Renders the official VerseSport slogan in the active UI language.
 * Hidden silently when the SuperAdmin disables it for a given section.
 */
export function BrandSlogan({
  section,
  className = "",
  size = "sm",
  withProduct = false,
  align = "center",
}: BrandSloganProps) {
  const { lang } = useLanguage();
  if (!isSloganEnabled(section)) return null;
  const text = getSlogan(lang);
  const alignCls = align === "center" ? "text-center" : "text-left";
  return (
    <p
      className={`font-medium tracking-wide text-muted-foreground/90 ${SIZE_MAP[size]} ${alignCls} ${className}`}
      data-pr35-slogan={section}
    >
      {withProduct && <span className="mr-1 font-black text-foreground">VerseSport</span>}
      <span className="italic opacity-90">{text}</span>
    </p>
  );
}